import { render, staticRenderFns } from "./productBrand.vue?vue&type=template&id=c7e98c16&scoped=true&"
import script from "./productBrand.vue?vue&type=script&lang=js&"
export * from "./productBrand.vue?vue&type=script&lang=js&"
import style0 from "./productBrand.vue?vue&type=style&index=0&id=c7e98c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e98c16",
  null
  
)

export default component.exports